import { CSSProperties } from 'react';

import { FilterType, HeaderRowGantType, PermissionScoreType } from './types';

export const HEIGHT_ITEM = 30;
export const HEIGHT_HEADER_ROW = 20;
export const WIDTH_COLUMN = 20;
export const WIDTH_COLUMN_WEEK = 20;
export const WIDTH_COLUMN_MONTH = 3;
export const WIDTH_COLUMN_QUARTER = 2;
export const WIDTH_COLUMN_YEAR = 1;
export const WIDTH_PERCENT_LEFT_HEADER = 15;
export const WIDTH_PERCENT_LEFT_HEADER_MAX = 40;
export const HEIGHT_SETTING_PANEL = 44;
export const OFFSET_WIDTH_LEFT_HEADER = 5;

export const STROKE_PARAM = {
    stroke: '#c5c5c5',
    strokeWidth: 0.5,
    style: { shapeRendering: 'crispEdges' } as CSSProperties,
};

export const COLOR_WEEKEND = '#d8d8d9';
export const COLOR_BACKGROUND_TASK = '#f9f9f9';
export const COLOR_GREY_E9 = '#e9e9e9';

export const COLOR_PARENT = '#e2a6fd';
export const COLOR_ITEM = '#abe0fc';
export const COLOR_MAIN_GRID = 'lightgrey';
export const COLOR_LIGHT_GRID = '#f5f4f4';
export const COLOR_DARK_GREY = 'darkgrey';
export const COLOR_MORE_DARK_GREY = '#505050';
export const COLOR_SELECT_ROW_GANT = '#faa16d';
export const COLOR_EMPTY_SPACE = '#F1F1F1';
export const COLOR_TOOLTIP = '#108ee9';
export const COLOR_ICON = '#5a608e';
export const COLOR_TAG_FILL = '#f1f1f1';
export const COLOR_TAG_FILL_ERROR = '#fff1f4';
export const COLOR_TAG_TEXT = '#222222';
export const COLOR_TAG_TEXT_ERROR = 'darkred';
export const COLOR_TAG_TEXT_HOVER = '#0858D9';
export const COLOR_TAG_TEXT_ERROR_HOVER = '#db0628';
export const COLOR_TAG_SELECT = 'rgba(59, 130, 246, 0.3)';
export const COLOR_ARROW_SELECT = '#47bd39';
export const COLOR_GANT_CALENDAR_SELECTION = '#faa16d';

export const COLOR_SET_LIST_TASK = ['#aaa', '#ccc', '#eee'];

export const BORDER_MAIN = `1px solid ${COLOR_MAIN_GRID}`;
export const BORDER_LIGHT = `1px solid ${COLOR_LIGHT_GRID}`;

export const FORMAT_DATE = 'yyyy-MM-dd';
export const FORMAT_DATE_DATEPICKER = 'DD-MM-YYYY';
export const FORMAT_DATE_FOR_SAVE = 'YYYY-MM-DD';

export const FORMAT_DATE_DISPLAY_DAY_SHORT = 'd LLL yyyy';
export const FORMAT_DATE_DISPLAY_DAY_SHORT2 = 'ccc dd, LLL';
export const FORMAT_DATE_DISPLAY_DAY = 'LLLL d, yyyy';
export const FORMAT_DATE_DISPLAY_MONTH = 'LLLL yyyy';
export const FORMAT_DATE_DISPLAY_MONTH_SHORT = 'LLL yyyy';
export const FORMAT_DATE_DISPLAY_YEAR = 'yyyy';
export const FORMAT_DATE_DISPLAY_MONTH_LIST = 'LLLL, yyyy';
export const FORMAT_TIME = 'HH:mm:ss';
export const FORMAT_DATE_TIME = 'yyyy-MM-dd hh:mm:ss';
export const FORMAT_TIME_FOR_SAVE = 'hh:mm:ss';
export const FORMAT_TIME_DISPLAY = 'hh:mm a';

export const ARROW_SIZE = 4;
export const ARROW_LENGTH = 6;
export const ARROW_MIN_OFFSET = 10;
export const ITEM_PERCENT_PADDING_TOP = 20;
export const ITEM_PERCENT_SIZE_ANGLE = 25;
export const ITEM_PARENT_PERCENT_HEIGHT = 70;
export const ITEM_PERCENT_HEIGHT = 60;
export const ITEM_PARENT_PADDING_TOP = 10;
export const LINE_PADDING_TOP = 47;
export const MARKER_PADDING_TOP = 50;
export const MARKER_PERCENTAGE_PADDING_TOP = 70;
export const MARKER_PERCENTAGE_SIZE = 6;
export const HEIGHT_ONE_PERCENT = HEIGHT_ITEM / 100;

export const storeHeaderRows: HeaderRowGantType = {
    // day: ['year', 'quarter', 'month', 'weekNum', 'day', 'dayWeek'],
    day: ['weekNum', 'dayWeek'],
    // week: ['year', 'quarter', 'month', 'weekNum'],
    week: ['weekNum2', 'day'],
    // month: ['year', 'quarter', 'month', 'weekNum'],
    month: ['month', 'weekNum3'],
    quarter: ['quarter', 'month2'],
    year: ['year', 'quarter', 'month'],
};

export const WEEKEND_DAYS = new Set([6, 7]);
export const WEEKEND_DAYS_2 = new Set([0, 6]);

export const COUNT_HOURS = 24;
export const COUNT_WEEK = 6;
export const HEIGHT_SCROLL = 23;
export const MINIMAL_LENGTH_FOR_SHOWING_TEXT = 12;
export const MAXIMUM_COUNT_FOR_SHOWING_TASK = 3;
export const WIDTH_COLUMN_CALENDAR_TIME = 60;

export const CELL_HEIGHT = 21;
export const PARTS_IN_HOUR = 2;
export const COUNT_DAY_IN_WEEK = 7;
export const HEIGHT_BAR_ITEM_SMALL = 6;
export const HEIGHT_BAR_ITEM_BIG = 17;
export const WIDTH_COLUMN_AGENDA_TIME = 150;
export const WIDTH_COLUMN_AGENDA_ITEM_TASK = 230;
export const GAP_COLUMN_AGENDA = 70;

export const LIST_PROJECT_STATUS = 'project_status';
export const LIST_GROUP_STATUS_PROJECT = 'group_status_project';
export const LIST_SCHEDULE_ITEM_TYPE = 'schedule_item_type';
export const LIST_TASK_GROUP_STATUS = 'task_group_status';
export const LIST_TASK_STATUS = 'task_status';
export const LIST_TASK_TYPE = 'task_type';
export const LIST_DIVISION = 'division';
export const LIST_COST_CODE = 'cost_code';
export const LIST_GROUP_PHASE = 'group_phase';
export const LIST_PHASE = 'phase';
export const LIST_CLASSIFICATION = 'classification';
export const LIST_PRIORITY = 'priority';
export const LIST_ICON_TASK_TYPE = 'icon_task_type';

export const PAGE_SIZE_ARRAY = ['1', '2', '5', '10', '20'];
export const [DEFAULT_PAGE_SIZE] = PAGE_SIZE_ARRAY;
export const PAGE_SIZE_LIST_ARRAY = ['100'];
export const [DEFAULT_PAGE_SIZE_LIST] = PAGE_SIZE_LIST_ARRAY;

export const TIMEOUT_BEFORE_AUTO_SAVING = 300;
export const MIN_VALUE_ITEMS_FOR_BLOCKING_SCREEN_LOADING = 10;
export const TIMEOUT_FOR_FILTER_TABLE = 500;
export const TIMEOUT_LEAVE_SELECT_ANDOR = 300;

export const TABLE_FILTER_CONDITION_WITHOUT_VALUE = new Set(['is_unknown', 'has_any_value']);

export const TABLE_FILTER_STRING: FilterType[] = [
    { type: 'is', requiredInput: true, inputType: 'String' },
    { type: 'is_not', requiredInput: true },
    { type: 'starts_with', requiredInput: true },
    { type: 'ends_with', requiredInput: true },
    { type: 'contains', requiredInput: true },
    { type: 'contains_exact_word', requiredInput: true },
    { type: 'does_not_contain', requiredInput: true },
    { type: 'is_unknown', requiredInput: false },
    { type: 'has_any_value', requiredInput: false },
];
export const TABLE_FILTER_NUMBER: FilterType[] = [
    { type: 'is', requiredInput: true, inputType: 'Int' },
    { type: 'is_not', requiredInput: true, inputType: 'Int' },
    { type: 'greater_than', requiredInput: true, inputType: 'Int' },
    { type: 'less_than', requiredInput: true, inputType: 'Int' },
    { type: 'between', requiredInput: true, inputType: 'Int' },
    { type: 'is_unknown', requiredInput: false },
    { type: 'has_any_value', requiredInput: false },
];
export const TABLE_FILTER_DATE: FilterType[] = [
    // { type: 'more_than', requiredInput: true, inputType: 'Date' },
    { type: 'exactly', requiredInput: true, inputType: 'Date' },
    { type: 'before', requiredInput: true, inputType: 'Date' },
    { type: 'after', requiredInput: true, inputType: 'Date' },
    // { type: 'on', requiredInput: true, inputType: 'Date' },
    { type: 'between', requiredInput: true, inputType: 'Date' },
    // { type: 'is_unknown', requiredInput: false },
    // { type: 'has_any_value', requiredInput: false },
];

export const DEFAULT_ITEM_NAME = 'Item_';

export const COUNT_RECORD_QUERY = 1000;
export const SETTING_GANT = 'gant';

export const GROUP_STATUS_TO_DO = 376;
export const GROUP_STATUS_IN_PROGRESS = 377;
export const GROUP_STATUS_DONE = 378;

export const DRAWER_WIDTH = 600;

export const propsArrowLine = {
    stroke: '#878787',
    strokeWidth: 1,
};

export const propsArrowLineBackground = {
    stroke: 'red',
    strokeWidth: 5,
    opacity: 0.01,
    cursor: 'pointer',
};

export const WIDTH_CARD_TASK_SMALL = 90;
export const WIDTH_CARD_TASK_MEDIUM = 140;
export const WIDTH_CARD_TASK_BIG = 250;

export const BUFFER_INPUT_DELAY = 500;

export const PERMISSION_TYPE_ALL = 'all';
export const PERMISSION_TYPE_OWNER = 'owner';
export const PERMISSION_TYPE_ASSIGNEE = 'assignee';
export const PERMISSION_TYPE_PROJECT = 'project';

export const PERMISSION_GROUP_TASK = 'schedule-task';
export const PERMISSION_GROUP_WORK_ITEM = 'work-item';
export const PERMISSION_GROUP_PROJECT = 'project';
export const PERMISSION_GROUP_USER = 'user';
export const PERMISSION_GROUP_FILES = 'files';
export const PERMISSION_GROUP_SETTINGS = 'settings';
export const PERMISSION_GROUP_DRAWING = 'drawing';

export const PERMISSION_ACTION_CREATE = 'create';
export const PERMISSION_ACTION_VIEW = 'view';
export const PERMISSION_ACTION_MANAGE = 'manage';
export const PERMISSION_ACTION_EDIT = 'edit';

export const permissionScoreData: PermissionScoreType = {
    group: {
        [PERMISSION_GROUP_TASK]: 100,
        [PERMISSION_GROUP_WORK_ITEM]: 200,
        [PERMISSION_GROUP_PROJECT]: 300,
        [PERMISSION_GROUP_USER]: 400,
        [PERMISSION_GROUP_FILES]: 500,
        [PERMISSION_GROUP_SETTINGS]: 600,
        [PERMISSION_GROUP_DRAWING]: 700,
    },
    type: {
        [PERMISSION_TYPE_ASSIGNEE]: 10,
        [PERMISSION_TYPE_OWNER]: 20,
        [PERMISSION_TYPE_ALL]: 30,
        [PERMISSION_TYPE_PROJECT]: 40,
    },
    action: {
        [PERMISSION_ACTION_VIEW]: 1,
        [PERMISSION_ACTION_CREATE]: 2,
        [PERMISSION_ACTION_EDIT]: 3,
        [PERMISSION_ACTION_MANAGE]: 4,
    },
};
